import React from "react";
import Protected from "./Protected";

import Home from "../../pages/home/Home";
import Register from "../../pages/auth/Register";
import Login from "../../pages/auth/Login";
import ForgotPassword from "../../pages/auth/ForgotPassword";
import ResetPassword from "../../pages/auth/resetPassword";

export const Auth = {
  element: <Protected />,
  //   errorElement: <RouterErrorPage />,
  children: [
    {
      element: <Home />,
      path: "/",
    },
    {
      element: <ForgotPassword />,
      path: "/forgot_password",
    },
    {
      element: <Login />,
      path: "/login",
    },
    {
      element: <Register />,
      path: "/signup",
    },
    {
      element: <ResetPassword />,
      path: "/reset_password",
    },
  ],
};
